import { FC } from 'react';
import { ShareOrgAssetTrigger } from '../../../../../../../../../shared/components';
import { useShareOrgAsset } from '../../../../../../../../../shared/hooks';
import { useCreateFormStepsStore } from '../../provider';

interface TemplateLocationPickerProps {
  usableLocationIds?: string[];
}

const TemplateLocationPicker: FC<TemplateLocationPickerProps> = ({ usableLocationIds }) => {
  const { selectedLocationIds, setSelectedLocationIds } = useCreateFormStepsStore([
    'selectedLocationIds',
    'setSelectedLocationIds',
  ]);
  const { ShareOrgAssetPopoverDialog, shareOrgAssestPopoverDialogControls } = useShareOrgAsset({
    popoverDialogConfig: {
      placement: 'bottom-start',
    },
  });

  return (
    <>
      <ShareOrgAssetTrigger
        getPopoverDialogTriggerProps={shareOrgAssestPopoverDialogControls.getTriggerProps}
        selectedLocationIds={selectedLocationIds}
      />
      <ShareOrgAssetPopoverDialog
        popoverDialogControls={shareOrgAssestPopoverDialogControls}
        selectedLocationIds={selectedLocationIds}
        initialLocationIds={usableLocationIds}
        onApply={setSelectedLocationIds}
      />
    </>
  );
};

export default TemplateLocationPicker;
